export const getScheduledScreenshotTimeout = (state) => state.tracking.delayedScreenshot.currentTimeoutId
export const getFirstScheduledScreenshotTime = (state) => state.tracking.delayedScreenshot.firstScreenshotTime
export const getFirstFurnitureScreenshotDone = (state) => state.tracking.delayedScreenshot.firstFurnitureScreenshotDone

export const getFurnitureFilterTrackingInfo = (state) => state.tracking.furnitureFilter
